<form [formGroup]="exportDataForm" (ngSubmit)="submit()">
  <div class="form-group">
    <label class="control-label">Location</label>

    <frontend-dropdown
      elementId="location-drop"
      formControlName="location"
      placeholder="All locations"
      [items]="locations"
      bindLabel="name"
      bindValue="_id"
    ></frontend-dropdown>
  </div>

  <div class="form-group">
    <label class="control-label">Select data to export</label>

    <p class="d-flex flex-row align-items-center">
      <tr-icon [icon]="icon.infoHeavy" [size]="iconSize.small" classes="pr-2"></tr-icon>
      Data is selected by its creation date.
    </p>

    <common-radio-group
      [items]="exportDataTypes"
      formControlName="exportDataType"
      uncheckedButtonClass="btn-outline-success"
      checkedButtonClass="btn-success"
      width="100%"
    ></common-radio-group>
    <control-messages [control]="exportDataTypeControl"></control-messages>
  </div>

  <div class="row" >
    <div class="col form-group" *ngIf="dateOptions$ | async as dateOptions">
      <label for="export-start" class="control-label">Start date</label>

      <input
        type="text"
        id="export-start"
        class="form-control"
        name="exportStartDate"
        placeholder="dd/mm/yyyy"
        formControlName="fromDate"
        [minDate]="dateOptions.minDate"
        [maxDate]="ngbEndDateValue"
        [firstDayOfWeek]="7"
        ngbDatepicker
        container="body"
        #startDateDatepicker="ngbDatepicker"
        (click)="startDateDatepicker.toggle()"/>
      <control-messages [control]="startDateControl"></control-messages>
    </div>

    <div class="col form-group" *ngIf="dateOptions$ | async as dateOptions">
      <label for="export-end" class="control-label">End date</label>

      <input
        type="text"
        id="export-end"
        class="form-control"
        name="exportEndDate"
        placeholder="dd/mm/yyyy"
        formControlName="toDate"
        [minDate]="ngbStartDateValue"
        [maxDate]="dateOptions.maxDate"
        [firstDayOfWeek]="7"
        ngbDatepicker
        container="body"
        #endDateDatepicker="ngbDatepicker"
        (click)="endDateDatepicker.toggle()"/>
      <control-messages [control]="endDateControl"></control-messages>
    </div>
  </div>

  <div class="form-group">
    <button type="submit" class="btn btn-info w-100" [disabled]="!exportDataForm.valid">Export data</button>
  </div>
</form>
